const xltIndex = () =>
  import(/* webpackChunkName: "xlt-index" */ 'page/xlt/index')
const xltGroup = () =>
  import(/* webpackChunkName: "xlt-group" */ 'page/xlt/group')
const xltMine = () => import(/* webpackChunkName: "xlt-mine" */ 'page/xlt/mine')

import { TAB_TYPE } from 'page/xlt/const.js'

const routes = [
  {
    path: `/xlt/${TAB_TYPE.consult}`,
    name: 'xltHome',
    component: xltIndex,
    meta: {
      business: '咨询',
      pageName: '心乐土',
      cache: false
    }
  },
  {
    path: `/xlt/${TAB_TYPE.group}`,
    name: 'xltGroup',
    component: xltGroup,
    meta: {
      business: '咨询',
      pageName: '团体活动',
      cache: false
    }
  },
  {
    path: `/xlt/${TAB_TYPE.mine}`,
    name: 'xltMine',
    component: xltMine,
    meta: {
      business: '咨询',
      pageName: '我的',
      cache: false
    }
  }
]

export default routes
